<template>
  <div
    class="cont-filter bg-white pd-h-10 pd-t-20 pd-b-20 d-flex align-items-center"
  >
    <span class="material-icons-outlined icon"> settings_input_component </span>

    <div class="input-comp input-comp-limited">
      <label class="form-control-label">CLIENTES</label>
      <v-select
        v-model="filters.customer"
        placeholder="Selecione uma opção"
        label="name"
        :options="customers"
        name="team"
		class="v-select-custom"
      >
        <template slot="option" slot-scope="option">
          <div v-if="option?.completeName" class="flex fd-c" style="border-bottom: 1px solid #e2e2e2;">
            <strong>{{ option.completeName }} <small>({{ option.name }})</small></strong>
            <span v-if="option?.federalID">CNPJ: {{ option.federalID }}</span>
			<span v-if="option?.city || option?.federalUnity">{{ option?.city || 'N/A' }} / {{ option?.federalUnity || 'N/A' }}</span>
          </div>
        </template>
      </v-select>
    </div>

    <div class="input-comp">
      <label for="grupo">EQUIPE / GRUPO</label>
      <select v-model="filters.team" name="team" id="grupo">
        <option value="">Selecione um time</option>
        <option v-for="team in teams" :value="team.id" :key="team.id" selected>
          {{ team.name }}
        </option>
      </select>
    </div>

    <div class="input-comp">
      <label for="grupo">ETAPA</label>
      <select v-model="filters.step" name="team" id="grupo">
        <option value="">Selecione uma etapa</option>
        <option v-for="step in steps" :value="step.id" :key="step.id" selected>
          {{ step.alias }}
        </option>
      </select>
    </div>

	<div class="input-comp" v-if="showIdentification">
      <label for="grupo">REF. DO PROCESSO</label>
      <input type="text" v-model="filters.identification" class="v-input">
    </div>
    <div>
      <button
        type="button"
        class="crm-button text-center flex ai-c fgap1"
		style="display: flex !important;"
        @click.prevent="findProcessesWithData"
      >
        <span class="material-icons-outlined"> cached </span>
        <span>{{ labelButton }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import config from "@/config.js";

import {mapState} from "vuex";

export default {
  name: "PartnerIntegrationsFilter",
  data() {
    return {
      customers: [],
      teams: [],
      firstDate: null,
      secondDate: null,
      filters: {
        customer: null,
        team: null,
        step: null,
		identification: null
      },
    };
  },
  components: {},
  mounted() {
    this.getCustomers();
    this.getOperationalTeams();
    this.$store.dispatch("ProcessStore/getSteps");
  },
  props: {
	labelButton: {
		type: String,
		default: 'ATUALIZAR',
	},
	showIdentification: {
		type: Boolean,
		default: false,
	},
  },
  computed: {
    ...mapState({
      steps: (state) => state.ProcessStore.steps,
    }),
  },
  methods: {
    findProcessesWithData() {
      const filters = {
        customerId: this.filters.customer ? this.filters.customer.id : null,
        teamId: this.filters.team ? this.filters.team : null,
        stepId: this.filters.step ? this.filters.step : null,
		identification: this.filters.identification || null
      };

      this.$emit("find-processes-with-data", filters);
    },
    getCustomers() {
      Axios.get(
        `${config.env.API_DEFAULT.host}/companies/search/findAllByIsCustomerOrderByName?isCustomer=true`
      ).then((response) => {
        this.customers = response.data._embedded.companies;
      });
    },
    getOperationalTeams() {
      Axios.get(`${config.env.API_DEFAULT.host}/teams`).then((response) => {
        this.teams = response.data._embedded.teams;
      });
    },
  },
};
</script>

<style scoped>
.cont-filter {
  gap: 20px;
}

.input-comp {
  flex: 1 1 auto;
}

.input-comp-limited {
  flex: 0 1 33%;
}

.input-comp.date {
  flex: 0 1 auto;
}

.input-comp select,
.input-comp input {
  border: 0;
  width: 100%;
  max-width: 100%;
  border-bottom: 1px solid var(--gray-dark);
  height: 35px;
}

.input-comp .mx-datepicker {
  display: block;
  width: 150px;
  max-width: 100%;
}

.filter-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 10px 15px;
  font-size: 14px;
  border: 0;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.2s ease-in-out 0s;
  background-color: var(--blue);
  color: #ffffff;
}

.icon {
  color: var(--gray-dark);
}
</style>

<style>

.cont-filter input {
  height: 40px !important;
}

body .input-comp .dropdown-toggle {
  display: flex;
  border: 0 !important;
  border-bottom: 1px solid var(--gray-dark) !important;
  min-height: 35px !important;
  border-radius: 0 !important;
}

.input-comp .v-select .open-indicator:before {
  border-color: black;
  border-width: 2px 2px 0 0;
  width: 7px;
  height: 7px;
}

.input-comp .dropdown-toggle input::placeholder {
  color: black;
}

.input-comp .mx-input-append::before {
  display: none;
}

.input-comp .mx-input-append {
  line-height: 0.5;
}

.input-comp .mx-input-wrapper .mx-clear-wrapper {
  margin-top: -3px !important;
  background-color: white !important;
  z-index: 9;
}

body .input-comp .mx-input-append svg {
  display: block !important;
}

</style>

<style>
.v-select-custom .dropdown-toggle .clear{
	top: 9px !important;	
}
</style>